import { useState, useEffect, useContext, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import PulseLoader from "react-spinners/PulseLoader";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from "@mui/icons-material/Download";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CollectionsIcon from "@mui/icons-material/Collections";
import StyleIcon from "@mui/icons-material/Style";
import PaletteIcon from "@mui/icons-material/Palette";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiAvatar from "components/SuiAvatar";
import SuiBadge from "components/SuiBadge";
import ReadMore from "components/UpStyled/ReadMore";

import CategoryContext from "context/category-context";
import { AccountContext } from "context/account";

import toast from "react-hot-toast";
import api from "services/api";
import moment from "moment";
import qs from "query-string";

import { BackTop } from "antd";

import breakpoints from "assets/theme/base/breakpoints";
import Error404 from "pages/error/404";
import ShareListModal from "pages/de/share-page/components/ShareListModal";
import SharedStyleList from "./components/SharedStyleList";
import SharedCollectionList from "./components/SharedCollectionList";
import SharedMoodboardList from "./components/SharedMoodboardList";

import SharedContentContext from "context/shared-content";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

const ResourceTabs = [
  { label: "All", icon: <ListAltIcon sx={{ mr: 1 }} />, value: "all" },
  { label: "Moodboards", icon: <PaletteIcon sx={{ mr: 1 }} />, value: "moodboard" },

  { label: "Collections", icon: <CollectionsIcon sx={{ mr: 1 }} />, value: "collection" },

  { label: "Styles", icon: <StyleIcon sx={{ mr: 1 }} />, value: "style" },
];

const SharedContentList = ({}) => {
  const [selectedPanel, setSelectedPanel] = useState("all");

  const location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);

  const { resourceList, retrieveContentPermission } = useContext(SharedContentContext);

  useEffect(() => {
    retrieveContentPermission();
  }, []);

  useEffect(() => {
    const tab = urlObj?.query?.tab;
    if (["all", "moodboard", "collection", "style"].includes(tab)) {
      setSelectedPanel(tab);
    }
  }, [url]);

  return (
    <SuiBox>
      <div>
        {/* <Card
          sx={{
            backdropFilter: `saturate(200%) blur(30px)`,
            backgroundColor: ({ functions: { rgba }, palette: { white } }) => rgba(white.main, 0.6),
            boxShadow: ({ boxShadows: { navbarBoxShadow } }) => navbarBoxShadow,
            position: "relative",
            px: 3,
            py: 1,
          }}
        >
          {" "}
          <SuiBox>
            <SuiBox display="flex" justifyContent="center" alignItems="center" gap={2}>
              <SuiButton
                size="large"
                variant="text"
                color={"dark"}
                onClick={() => setSelectedPanel("all")}
                sx={{
                  backgroundColor: ({ palette }) =>
                    selectedPanel == "all" ? palette?.lightBlue?.main : null,
                  "&:hover": {
                    color: ({ palette }) => palette?.dark?.main,
                    backgroundColor: ({ palette }) => palette?.secondary?.main,
                  },
                }}
              >
                {" "}
                <ListAltIcon sx={{ mr: 1 }} />
                <SuiBox sx={{ display: { xs: "none", sm: "block" } }}>All</SuiBox>
              </SuiButton>
              <SuiButton
                size="large"
                variant="text"
                color="dark"
                onClick={() => setSelectedPanel("moodboard")}
                sx={{
                  backgroundColor: ({ palette }) =>
                    selectedPanel == "moodboard" ? palette?.lightBlue?.main : null,
                  "&:hover": {
                    color: ({ palette }) => palette?.dark?.main,
                    backgroundColor: ({ palette }) => palette?.secondary?.main,
                  },
                }}
              >
                {" "}
                <PaletteIcon sx={{ mr: 1 }} />
                <SuiBox sx={{ display: { xs: "none", sm: "block" } }}>Moodboards</SuiBox>
              </SuiButton>
              <SuiButton
                size="large"
                variant="text"
                color="dark"
                onClick={() => setSelectedPanel("collection")}
                sx={{
                  backgroundColor: ({ palette }) =>
                    selectedPanel == "collection" ? palette?.lightBlue?.main : null,
                  "&:hover": {
                    color: ({ palette }) => palette?.dark?.main,
                    backgroundColor: ({ palette }) => palette?.secondary?.main,
                  },
                }}
              >
                {" "}
                <CollectionsIcon sx={{ mr: 1 }} />
                <SuiBox sx={{ display: { xs: "none", sm: "block" } }}>Collections</SuiBox>
              </SuiButton>

              <SuiButton
                size="large"
                variant="text"
                color="dark"
                onClick={() => setSelectedPanel("style")}
                sx={{
                  backgroundColor: ({ palette }) =>
                    selectedPanel == "style" ? palette?.lightBlue?.main : null,
                  "&:hover": {
                    color: ({ palette }) => palette?.dark?.main,
                    backgroundColor: ({ palette }) => palette?.secondary?.main,
                  },
                }}
              >
                {" "}
                <StyleIcon sx={{ mr: 1 }} />
                <SuiBox sx={{ display: { xs: "none", sm: "block" } }}>Styles</SuiBox>
              </SuiButton>
            </SuiBox>
          </SuiBox>
        </Card> */}

        <Card
          sx={{
            backdropFilter: `saturate(200%) blur(30px)`,
            backgroundColor: ({ functions: { rgba }, palette: { white } }) => rgba(white.main, 0.6),
            boxShadow: ({ boxShadows: { navbarBoxShadow } }) => navbarBoxShadow,
            position: "relative",
            px: 3,
            py: 1,
          }}
        >
          {" "}
          <SuiBox>
            <SuiBox display="flex" justifyContent="center" alignItems="center" gap={2}>
              <Tabs
                value={selectedPanel}
                onChange={(e, newValue) => setSelectedPanel(newValue)}
                aria-label="basic tabs example"
              >
                {ResourceTabs.map((item, index) => (
                  <Tab
                    label={
                      <SuiBox display="flex" alignItems="center">
                        {item.icon}
                        <SuiBox sx={{ display: { xs: "none", sm: "block" } }}>{item.label}</SuiBox>
                      </SuiBox>
                    }
                    value={item.value}
                    sx={{ px: 4 }}
                  />
                ))}
              </Tabs>
            </SuiBox>
          </SuiBox>
        </Card>

        <div>
          {selectedPanel == "all" || selectedPanel == "moodboard" ? (
            <Card id="shared-moodboards" sx={{ px: 3, py: 3, mt: 2 }}>
              <SuiTypography variant="h6" sx={{ my: 1 }}>
                Shared Moodboards
              </SuiTypography>
              <SharedMoodboardList />
            </Card>
          ) : null}
          {selectedPanel == "all" || selectedPanel == "collection" ? (
            <Card id="shared-collections" sx={{ px: 3, py: 3, mt: 2 }}>
              <SuiTypography variant="h6" sx={{ my: 1 }}>
                Shared Collections
              </SuiTypography>
              <SharedCollectionList />
            </Card>
          ) : null}

          {selectedPanel == "all" || selectedPanel == "style" ? (
            <Card id="shared-styles" sx={{ px: 3, py: 3, mt: 2 }}>
              <SuiTypography variant="h6" sx={{ my: 1 }}>
                Shared Styles
              </SuiTypography>

              <SharedStyleList />
            </Card>
          ) : null}
        </div>
      </div>
      <BackTop />
    </SuiBox>
  );
};

export default SharedContentList;
